import { CoachingLeaderboardView } from '@euler/model/coaching-progress';
import { useServiceFactory } from '@euler/services/factory';
import { useCallback, useEffect, useState } from 'react';

/** 本周练习榜 of the trainee's store. */
export function useCoachingLeaderboard() {
  const { coachingService } = useServiceFactory();
  const [board, setBoard] = useState<CoachingLeaderboardView | null>(null);
  const [failed, setFailed] = useState(false);
  const [reloadKey, setReloadKey] = useState(0);
  const reload = useCallback(() => setReloadKey(k => k + 1), []);
  useEffect(() => {
    let active = true;
    coachingService
      .getLeaderboard()
      .then(value => {
        if (!active) return;
        setBoard(value);
        setFailed(false);
      })
      .catch(error => {
        console.error('coaching leaderboard failed', error);
        if (active) setFailed(true);
      });
    return () => {
      active = false;
    };
  }, [coachingService, reloadKey]);
  return { board, failed, reload };
}
